//获取移动端系统版本号ios1.0 设备名称 小米
import MobileDetect from 'mobile-detect'
import dbmap from './../dbs/hashmap'
/*设置cookie*/
var utils = {
    cookie: {
        // 设置cookie
        setCookie: function(name, value, expire) {
            var date = new Date()
            if (!expire) {
                expire = 20 * 60
            }
            date.setSeconds(date.getSeconds() + expire)
            document.cookie = name + '=' + escape(value) + '; expires=' + date.toGMTString() + ';path=/'
        },
        /*获取cookie*/
        getCookie: function(name) {
            if (document.cookie.length > 0) {
                let start = document.cookie.indexOf(name + '=')
                if (start !== -1) {
                    start = start + name.length + 1
                    let end = document.cookie.indexOf(';', start)
                    if (end === -1) {
                        end = document.cookie.length
                    }
                    return unescape(document.cookie.substring(start, end))
                }
            }
            return ''
        },
        /*删除cookie*/
        delCookie: function(name) {
            this.setCookie(name, '', -1)
        }
    },
    storage: {
        // 获取本地存储
        fetchStorage: function(key) {
            return JSON.parse(window.localStorage.getItem(key || '[]'))
        },
        // 保存localStorage的数据
        setStorage: function(key, items) {
            window.localStorage.setItem(key, JSON.stringify(items))
        },
        // 清除所有的的存储
        clearStorage: function() {
            window.localStorage.clear()
        }
    },
    // 字符串
    strUtil: {
        /*
         * 判断字符串是否为空
         * @param str 传入的字符串
         * @returns {}
         */
        isEmpty: function(str) {
            if (str !== undefined && str !== null && str.length > 0) {
                return false
            }
            return true
        },
        /*
         * 判断两个字符串子否相同
         * @param str1
         * @param str2
         * @returns {Boolean}
         */
        isEquals: function(str1, str2) {
            if (str1 === str2) {
                return true
            }
            return false
        },
        /*
         * 忽略大小写判断字符串是否相同
         * @param str1
         * @param str2
         * @returns {Boolean}
         */
        isEqualsIgnorecase: function(str1, str2) {
            if (str1.toUpperCase() === str2.toUpperCase()) {
                return true
            }
            return false
        },
        /**
         * 判断是否是数字
         * @param value
         * @returns {Boolean}
         */
        isNum: function(value) {
            if (value !== null && value.length > 0 && isNaN(value) === false) {
                return true
            }
            return false
        },
        /**
         * 判断是否是中文
         * @param str
         * @returns {Boolean}
         */
        isChine: function(str) {
            var reg = /^([u4E00-u9FA5]|[uFE30-uFFA0])*$/
            if (reg.test(str)) {
                return false
            }
            return true
        },
        ifNullThen: function(str, value) {
            return this.isEmpty(str) ? value : str
        }
    },
    // 日期
    dateUtil: {
        /*
         * 方法作用：【取传入日期是星期几】
         * 使用方法：dateUtil.nowFewWeeks(new Date());
         * @param date{date} 传入日期类型
         * @returns {星期四，...}
         */
        nowFewWeeks: function(date) {
            if (date instanceof Date) {
                var dayNames = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
                return dayNames[date.getDay()]
            }
            return 'Param error,date type!'
        },
        /*
         * 方法作用：【字符串转换成日期】
         * 使用方法：dateUtil.strTurnDate('2010-01-01');
         * @param str {String}字符串格式的日期，传入格式：yyyy-mm-dd(2015-01-31)
         * @return {Date}由字符串转换成的日期
         */
        strTurnDate: function(str) {
            var re = /^(\d{4})\S(\d{1,2})\S(\d{1,2})$/
            var dt
            if (re.test(str)) {
                dt = new Date(RegExp.$1, RegExp.$2 - 1, RegExp.$3)
            }
            return dt
        },
        //20180101转成2018-01-01
        strToDate: function(str, space) {
            if (str.length !== 8) {
                return false
            }
            if (!space) {
                space = '.'
            }
            return str.slice(0, 4) + space + str.slice(4, 6) + space + str.slice(6, 8)
        },
        /**
         * 方法作用：【格式化时间】
         * 使用方法
         *      date：需要为时间格式
         *
         *      format：为时间格式
         *      'yyyy年MM月dd日';
         *      'MM/dd/yyyy';
         *      'yyyyMMdd';
         *      'yyyy-MM-dd hh:mm:ss';
         */
        dateFormat: function(date, format) {
            var o = {
                'M+': date.getMonth() + 1, //month
                'd+': date.getDate(), //day
                'h+': date.getHours(), //hour
                'm+': date.getMinutes(), //minute
                's+': date.getSeconds(), //second
                'q+': Math.floor((date.getMonth() + 3) / 3), //quarter
                'S': date.getMilliseconds() //millisecond
            }
            if (/(y+)/.test(format)) {
                format = format.replace(RegExp.$1, String(date.getFullYear()).substr(4 - RegExp.$1.length))
            }
            for (var k in o) {
                if (new RegExp('(' + k + ')').test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(String(o[k]).length))
                }
            }
            return format
        },
        /*
         * 方法作用：【计算2个日期之间的天数】
         * 传入格式：yyyy-mm-dd(2015-01-31)
         * 使用方法：dateUtil.dayMinus(startDate,endDate)
         * @startDate {Date}起始日期
         * @endDate {Date}结束日期
         * @return endDate - startDate的天数差
         */
        dayMinus: function(startDate, endDate) {
            if (startDate instanceof Date && endDate instanceof Date) {
                var days = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24))
                return days
            }
            return 'Param error,date type!'
        },
        add0: function(m) { return m < 10 ? '0' + m : m },
        format: function(shijianchuo, ymr) {
            //shijianchuo是整数，否则要parseInt转换
            var time = new Date(shijianchuo)
            var y = time.getFullYear()
            var m = time.getMonth() + 1
            var d = time.getDate()
            var h = time.getHours()
            var mm = time.getMinutes()
            var s = time.getSeconds()
            if (ymr) {
                return y + '-' + this.add0(m) + '-' + this.add0(d)
            }
            return y + '-' + this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm) + ':' + this.add0(s)
        }

    },
    tools: {
        // 获取url的参数
        getUrlParam: function(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') //构造一个含有目标参数的正则表达式对象
            var r = window.location.search.substr(1).match(reg) //匹配目标参数
            if (r !== null) {
                return decodeURIComponent(r[2])
            }
            return '' //返回参数值
        },
        IdentityCodeValid: function(code) {
            var city = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江 ', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外' }
            // var tip = ''
            var pass = true

            if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
                // tip = '身份证号格式错误'
                pass = false
            } else if (!city[code.substr(0, 2)]) {
                // tip = '地址编码错误'
                pass = false
            } else if (code.length === 18) {
                //18位身份证需要验证最后一位校验位
                code = code.split('')
                //∑(ai×Wi)(mod 11)
                //加权因子
                var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
                //校验位
                var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
                var sum = 0
                var ai = 0
                var wi = 0
                for (var i = 0; i < 17; i++) {
                    ai = code[i]
                    wi = factor[i]
                    sum += ai * wi
                }
                if (parity[sum % 11] !== code[17]) {
                    // tip = '校验位错误'
                    pass = false
                }
            }
            return pass
        },
        isPhone: function(mobilePhone) {
            var past = /^1[3-9]\d{9}$/
            return past.test(mobilePhone)
        },
        //汉字校验
        nameValid: function(name) {
            var reg = /^[\u4e00-\u9fa5]+$/
            return reg.test(name)
        },
        numAlphaValid: function(str) {
            if (!str.match('^[A-Za-z0-9]+$')) {
                return false
            }
            return true
        },
        redirectUrl: function(url) {
            var el = document.createElement('a')
            document.body.appendChild(el)
            el.href = url
            el.target = '_blank'
            el.click()
            document.body.removeChild(el)
        },
        //邮箱校验
        checkEmail: function(email) {
            if (!email.match('^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$')) {
                return false
            }
            return true
        },
        // 只能输入数字-#*
        checkTelp: function(telp) {
            var reg = /^[\d-*#]+$/
            return reg.test(telp)
        }
    },
    getInfomation:{
        init(){
            if(this.isWeiXin()){
                dbmap.set('terminalType','Mobile')
                dbmap.set('messageChannel','WeChatWebBrowser')
                console.log('您的浏览设备为：Mobile,信息抓去渠道：WeChatWebBrowser')
            }else{
                this.browserRedirect()
            }
        },
        isWeiXin(){
            //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
            var ua = window.navigator.userAgent.toLowerCase();
            //通过正则表达式匹配ua中是否含有MicroMessenger字符串
            if(ua.match(/MicroMessenger/i) == 'micromessenger'){
                return true;
            }else{
                return false;
            }
        },
        mobileInfo(){
            Array.prototype.contains = function(needle) { 
              for (i in this) { 
                if (this[i].indexOf(needle) > 0) 
                  return i; 
              } 
              return -1; 
            } 
            var device_type = navigator.userAgent;//获取userAgent信息  
            var md = new MobileDetect(device_type);//初始化mobile-detect 
            var os = md.os();//获取系统 
            var model = ""; 
            if (os == "iOS") {//ios系统的处理 
              os = md.os() + md.version("iPhone"); 
              model = md.mobile(); 
            } else if (os == "AndroidOS") {//Android系统的处理 
              os = md.os() + md.version("Android"); 
              var sss = device_type.split(";"); 
              var i = sss.contains("Build/"); 
              if (i > -1) { 
                model = sss[i].substring(0, sss[i].indexOf("Build/")); 
              } 
            } 
            dbmap.set('systemVersion', os)
            dbmap.set('equipmentType', model)
            console.log('移动端设备类型：'+ os + "，设备名称型号：" + model) 
        },
        browserRedirect() {
            var sUserAgent = navigator.userAgent.toLowerCase();
            var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
            var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
            var bIsMidp = sUserAgent.match(/midp/i) == "midp";
            var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
            var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
            var bIsAndroid = sUserAgent.match(/android/i) == "android";
            var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
            var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
            if (bIsIphoneOs || bIsUc  || bIsUc7 || bIsAndroid || bIsCE) {
                dbmap.set('terminalType','Mobile')
                dbmap.set('messageChannel','H5WebBrowser')
                console.log('您的浏览设备为：Mobile,信息抓去渠道：H5WebBrowser')
                this.mobileInfo()
            } else if (bIsIpad || bIsMidp || bIsWM) {
                dbmap.set('terminalType','iPad')
                dbmap.set('messageChannel','iPadWebBrowser')
                console.log('您的浏览设备为：iPad,信息抓去渠道：iPadWebBrowser')
                this.mobileInfo()
            } else {
                dbmap.set('terminalType','PC')
                dbmap.set('messageChannel','PCWebBrowser')
                console.log('您的浏览设备为：PC，信息抓取渠道：PCWebBrowser')
                this.driveInfo()
            }
        },
        driveInfo(){
            var BrowserMatch = {  
                     init: function() {  
                         this.browser = this.getBrowser().browser || "未知浏览器";  //获取浏览器名
                         this.version = this.getBrowser().version || "未知浏览器版本号";  //获取浏览器版本
                         this.OS = this.getOS()+" "+this.getDigits() || "未知操作系统"; //系统版本号 
                     },  
                     getOS: function() {  //判断所处操作系统
                            var sUserAgent = navigator.userAgent.toLowerCase();   
                           
                           var isWin = (navigator.platform == "Win32") || (navigator.platform == "Win64")|| (navigator.platform == "wow64");   
                           
                           var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");   
                           if (isMac) return "Mac";   
                           var isUnix = (navigator.platform == "X11") && !isWin && !isMac;   
                           if (isUnix) return "Unix";   
                           var isLinux = (String(navigator.platform).indexOf("Linux") > -1);   
                           var bIsAndroid = sUserAgent.toLowerCase().match(/android/i) == "android";  
                           if (isLinux) {  
                           if(bIsAndroid) return "Android";  
                           else return "Linux";   
                           }  
                           if (isWin) {   
                           
                               var isWin2K = sUserAgent.indexOf("Windows nt 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;   
                               if (isWin2K) return "Win2000";   
                               var isWinXP = sUserAgent.indexOf("Windows nt 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1  
                               sUserAgent.indexOf("Windows XP") > -1;   
                               if (isWinXP) return "WinXP";   
                               var isWin2003 = sUserAgent.indexOf("Windows nt 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;   
                               if (isWin2003) return "Win2003";   
                               var isWinVista= sUserAgent.indexOf("Windows nt 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;   
                               if (isWinVista) return "WinVista";   
                               var isWin7 = sUserAgent.indexOf("Windows nt 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;   
                               if (isWin7) return "Win7";   
                               var isWin8 = sUserAgent.indexOf("windows nt 6.2") > -1 || sUserAgent.indexOf("Windows 8") > -1;  
                               if (isWin8) return "Win8"; 
                               var isWin10 = sUserAgent.indexOf("windows nt 10.0")>-1||sUserAgent.indexOf("Windows 10")>-1;	
                               if(isWin10)return "Win10";				
                           }  
                           return "其他";
                     },  
                     getDigits:function(){ //判断当前操作系统的版本号 
                       var sUserAgent = navigator.userAgent.toLowerCase();   
                       var is64 = sUserAgent.indexOf("win64") > -1||sUserAgent.indexOf("wow64") > -1;  
                       if (is64) {  
                           return "64位";  
                       }else{  
                          return "32位";    
                       }  
                   },
                     getBrowser: function() {  // 获取浏览器名
                         var rMsie = /(msie\s|trident\/7)([\w\.]+)/;  
                         var rTrident = /(trident)\/([\w.]+)/;  
                         var rEdge = /(chrome)\/([\w.]+)/;//IE
                         
                         var rFirefox = /(firefox)\/([\w.]+)/;  //火狐
                         var rOpera = /(opera).+version\/([\w.]+)/;  //旧Opera
                         var rNewOpera = /(opr)\/(.+)/;  //新Opera 基于谷歌
                         var rChrome = /(chrome)\/([\w.]+)/; //谷歌 
                         var rUC = /(chrome)\/([\w.]+)/;//UC
                         var rMaxthon = /(chrome)\/([\w.]+)/;//遨游
                         var r2345 =  /(chrome)\/([\w.]+)/;//2345
                         var rQQ =  /(chrome)\/([\w.]+)/;//QQ
                         //var rMetasr =  /(metasr)\/([\w.]+)/;//搜狗
                         var rSafari = /version\/([\w.]+).*(safari)/;
                         
                         var ua = navigator.userAgent.toLowerCase();  
            
            
                         var matchBS, matchBS2;  
                         
                         if(ua.match(/MicroMessenger/i) == 'micromessenger'){
                            return {  
                                browser: "微信浏览器",  
                                version: "微信版本"+ua.match(/MicroMessenger\/([\d\.]+)/i)[1]
                            };
                         }
                         //IE 低版
                         matchBS = rMsie.exec(ua);  
                         if (matchBS != null) {  
                             matchBS2 = rTrident.exec(ua);  
                             if (matchBS2 != null) {  
                                 switch (matchBS2[2]) {  
                                 case "4.0":  
                                     return {  
                                         browser:  
                                         "Microsoft IE",  
                                         version: "IE: 8"  //内核版本号
                                     };  
                                     break;  
                                 case "5.0":  
                                     return {  
                                         browser:  
                                         "Microsoft IE",  
                                         version: "IE: 9"  
                                     };  
                                     break;  
                                 case "6.0":  
                                     return {  
                                         browser:  
                                         "Microsoft IE",  
                                         version: "IE: 10"  
                                     };  
                                     break;  
                                 case "7.0":  
                                     return {  
                                         browser:  
                                         "Microsoft IE",  
                                         version: "IE: 11"  
                                     };  
                                     break;  
                                 default:  
                                     return {  
                                         browser:  
                                         "Microsoft IE",  
                                         version: "Undefined"  
                                     };  
                                 }  
                             } else {  
                                 return {  
                                     browser: "Microsoft IE",  
                                     version: "IE:"+matchBS[2] || "0"  
                                 };  
                             }  
                         }  
                         //IE最新版
                          matchBS = rEdge.exec(ua);  	 				   
                         if ((matchBS != null) && (!(window.attachEvent))) {  
                             return {  
                                 browser: "Microsoft Edge",  
                                 version: "Chrome/"+matchBS[2] || "0"  
                             };  
                         }  
                                             //UC浏览器					  
                         matchBS = rUC.exec(ua);                         		   
                         if ((matchBS != null) && (!(window.attachEvent))) {  
                             return {  
                                 browser: "UC",  
                                 version: "Chrome/"+matchBS[2] || "0"  
                             };  
                         }  
                         //火狐浏览器
                         matchBS = rFirefox.exec(ua);  
                         if ((matchBS != null) && (!(window.attachEvent))) {  
                             return {  
                                 browser: "火狐",  
                                 version: "Firefox/"+matchBS[2] || "0"  
                             };  
                         }  
                                            //Oper浏览器					 
                        matchBS = rOpera.exec(ua);  
                         if ((matchBS != null) && (!(window.attachEvent))) {  
                             return {  
                                 browser: "Opera",  
                                 version: "Chrome/"+matchBS[2] || "0"  
                             };  
                         }  
                         //遨游
                          matchBS = rMaxthon.exec(ua);  	 				   
                         if ((matchBS != null) && (!(window.attachEvent))) {  
                             return {  
                                 browser: "遨游",  
                                 version: "Chrome/"+matchBS[2] || "0"  
                             };  
                         }  
                                             //2345浏览器					  
                          matchBS = r2345.exec(ua);  	 				   
                         if ((matchBS != null) && (!(window.attachEvent))) {  
                             return {  
                                 browser: "2345",  
                                 version: "Chrome/ "+matchBS[2] || "0"  
                             };  
                         }  
                                             //QQ浏览器					  
                         matchBS = rQQ.exec(ua);  	 				   
                         if ((matchBS != null) && (!(window.attachEvent))) {  
                             return {  
                                 browser: "QQ",  
                                 version: "Chrome/"+matchBS[2] || "0"  
                             };  
                         }  
                         //Safari（苹果）浏览器
                         matchBS = rSafari.exec(ua);  
                         if ((matchBS != null) && (!(window.attachEvent)) && (!(window.chrome)) && (!(window.opera))) {  
                             return {  
                                 browser: "Safari",  
                                 version: "Safari/"+matchBS[1] || "0"  
                             };  
                         }
                        
                         //谷歌浏览器
                          matchBS = rChrome.exec(ua);  
                         if ((matchBS != null) && (!(window.attachEvent))) {  
                             matchBS2 = rNewOpera.exec(ua);  
                             if (matchBS2 == null) {  
                                 return {  
                                     browser: "谷歌",  
                                     version: "Chrome/"+matchBS[2] || "0"  
                                 };  
                             } else {  
                                 return {  
                                     browser: "Opera",  
                                     version: "opr/"+matchBS2[2] || "0"  
                                 };  
                             }  
                         }  
                     }  
            };  
            BrowserMatch.init()
            dbmap.set('browserTypeVersion', BrowserMatch.version)
            dbmap.set('systemVersion', BrowserMatch.OS)
            console.log("当前浏览器为：" + BrowserMatch.browser +"\n版本为："+ BrowserMatch.version + "\n所处操作系统为："+BrowserMatch.OS); 
        }
    },
    routerJump:{
        returnUrl(code){
            var params = {
                url:'',
                title:'',
                message:'',
                code:'',
                showbutton:[], // 1 返回汇丰 2.重新认证 3.立即登录  4 重试  5返回 6 立即注册
            };
            switch(code){
                case "0001":
                    params.url = 'index';
                    break;
                case "0002":
                    params.url = 'questionnaire';
                    break;
                case "0003":
                    params.url = 'additionalMaterials';
                    break;
                case "0004":// 四要素
                    params.url = 'stepDescription';
                    break;
                case "0043":
                    params.url = 'reVerified';
                    break;
                case "0041"://007_3 请勿重复提交
                    params.url = 'cupLoginTip';
                    break;
                case "0005":
                    params.url = 'loanChannel';
                    break;
                case "0006":
                    params.url = 'peopleVerification';
                    break;
                case "0007":
                    params.url = 'loanConfirmation';
                    break;
                case "0008":
                    params.url = 'login';
                    break;
                case "0009":
                    params.url = 'loanLoops';
                    break;
                case "0010":
                    params.url = 'loanPurpose';
                    break;
                case "0011":
                    params.url = 'acceptLoan';
                    break;
                case "0012":
                    params.url = 'entityKYC';
                    break;
                case "0013":
                    params.url = 'loanLoops';
                    break;
                case "0015":
                    params.url = 'loanPurpose';
                    break;
                case "0016":
                    params.url = 'stepDescription';
                    break;
                case "0017":
                    params.url = 'loanPaymentType';
                    break;
                case "0018":
                    params.url = 'linkPeople';
                    break;
                case "0019":
                    params.url = 'informationConfirmed';
                    break;
                case "0020"://007_1 后台返回 四要素信息不匹配
                    params.url = 'corpLegalFail';
                    break;
                // case "0022"://007_1 后台返回 四要素信息不匹配
                //     params.url = 'feedBack';
                //     params.title = '非常抱歉！';
                //     params.message = '关联人不存在！';
                //     break;
                case "0023"://问卷调查不符合规则 003_2
                    params.url = 'feedBack';
                    params.title = '非常抱歉！';
                    params.message = '感谢您选择汇丰中国。很抱歉，您暂未符合个人经营性贷款申请条件，如需了解其他产品和服务，请致电汇丰汇融客户服务热线400-820-1177。 ';
                    params.code = code;
                    break;
                case "0024": //005
                    params.url = 'authorizationResult';
                    params.title = '税务信息授权成功';
                    params.message = '请点按下一步继续进行申请。';
                    params.code = code;
                    break;
                case "0040": //005_3 有手机尾号返回
                    params.url = 'authorizationResult';
                    params.title = '税务信息授权成功';
                    params.message = '';
                    params.code = code;
                    break;
                case "0025": //005_2
                    params.url = 'authorizationResult';
                    params.title = '税务信息授权失败';
                    params.message = '您可选择再次授权或返回个人经营性贷款平台首页';
                    params.code = code;
                    break;
                case "0026"://通用网络连接超时
                    params.url = 'feedBack';
                    params.title = '网络连接超时！';
                    params.message = '网络连接超时，请稍后再试。';
                    params.code = code;
                    params.showbutton = ['4'];
                    break;
                case "0028": //015  036
                    params.url = 'editAgain';
                    break;
                case "0029": //015  036
                    params.url = 'acceptLoan';
                    break;
                case "0030"://登录后 审批拒绝 034 043 023 040_1 040
                    params.url = 'approvalRefuse';

                    break;
                case "0031": //015  036
                    params.url = 'feedBack';
                    params.title = '提交审核中';
                    params.message = '我们已经收到并正在审核您提交的前述信息，审查结果将以短信形式告知，请注意查收。如审查通过，请登录本平台继续贷款申请流程。';
                    params.code = code;
                    params.showbutton = ['1'];
                    break;
                    
                case "0032"://选择放弃原因 放弃申请 024
                    params.url = 'feedBack';
                    params.title = '申请已关闭';
                    // params.message = '抱歉，您已放弃申请。感谢您对汇丰小企业银行服务的关注和支持。如需了解其他产品和服务，请致电汇丰汇融客户服务热线400-820-1177或访问汇丰汇融官网https://www.hsbc.com.cn/fusion/。如果您想退出申请流程，请直接关闭当前浏览器页面；如果您想再次申请，请点击“重新申请”，您将回到首页重新开始申请流程。';
                    params.message = '抱歉，您已放弃申请。感谢您对汇丰小企业银行服务的关注和支持。如需了解其他产品和服务，请致电汇丰汇融客户服务热线400-820-1177或访问汇丰汇融官网https://www.hsbc.com.cn/fusion/。如果您想退出申请流程，请直接关闭当前浏览器页面。';
                    // params.showbutton = ['8'];
                    break;
                case "0033":// kyc未填写 offer未接收 贷款未提交 银行流水未上传 035
                    params.url = 'feedBack';
                    params.title = '申请已关闭';
                    params.message = '抱歉，由于您的贷款申请已超时，我们已为您自动取消此申请。如您对汇丰银行个人经营性贷款感兴趣，请点击下方“重新申请”再次提交申请。';
                    params.code = code;
                    params.showbutton = ['7']
                    break;
                case "0042":// 微众税银没有拿到结果超时 022
                    params.url = 'feedBack';
                    params.title = '申请已关闭';
                    params.message = '抱歉，由于您的贷款申请已超时，我们已为您自动取消此次申请。如您对汇丰银行个人经营性贷款感兴趣，请点击下方“重新申请”再次提交申请。';
                    params.code = code;
                    params.showbutton = ['7']
                    break;
                case "0034": //027
                    params.url = 'feedBack';
                    params.title = '尚未注册';
                    params.message = '请完成注册后继续预申请。';
                    params.code = code;
                    params.showbutton = ['6']
                    break;
                case "0035": //007_4 etb 四要素认证返回 不满足申请条件
                    params.url = 'feedBack';
                    params.title = '抱歉，您尚未满足申请条件';
                    params.message = '感谢您对汇丰村镇银行服务的关注和支持。如需了解其他产品和服务，汇丰村镇银行客户服务热线：400-820-3919或联系您的客户经理或访问汇丰村镇银行官网https://www.hsbc.com.cn/rural-bank/';
                    params.code = code;
                    params.showbutton = ['1']
                    break;
                case "0037": //0037 etb 认证失败
                    params.url = 'feedBack';
                    params.title = '抱歉，您未能完成个人身份验证及征信信息查询授权。';
                    params.messages = '请重试或告知借款申请人相关情况，我们的客户经理将与您或借款申请人联系。';
                    params.message = '感谢您对汇丰村镇银行服务的关注和支持。如需了解其他产品和服务，汇丰村镇银行客户服务热线：400-820-3919或联系您的客户经理或访问汇丰村镇银行官网https://www.hsbc.com.cn/rural-bank/';
                    params.code = code;
                    params.showbutton = ['1']
                    break;
                case "0036": //企业信息认证达到上限
                    params.url = 'feedBack';
                    params.title = '抱歉，企业信息认证已达上限!';
                    params.message = '当天认证已达上限，请您24小时后重试。';
                    params.code = code;
                    params.showbutton = ['1']
                    break;
                case "0039": //登录失效
                    params.url = 'feedBack';
                    params.title = '登录失效!';
                    params.message = '当前登录失效，请重新登录';
                    params.code = code;
                    params.showbutton = ['3']
                    break;
                case "0044": //pcwk 已登录
                    params.url = 'feedBack';
                    params.title = '申请已关闭!';
                    params.message = '抱歉，您存在未完成的其他产品贷款申请。感谢您对汇丰小企业银行服务的关注和支持。如需了解，请致电汇丰汇融客户服务热线400-820-1177或访问汇丰汇融官网https://www.hsbc.com.cn/fusion/。如果您想退出申请流程，请直接关闭当前浏览器页面。';
                    params.code = code;
                    break;
                case "0045": // 
                    params.url = 'feedBack';
                    params.title = '重新登录!';
                    params.message = '请由商户指定链接重新登录继续您的申请！';
                    params.code = code;
                    break;
                case "0046": // 
                    params.url = 'feedBack';
                    params.title = '重新登录!';
                    params.message = '抱歉，您存在未完成的贷款申请。请重新登录！';
                    params.code = code;
                    params.showbutton = ['3']
                    break;
                case "0047": // 
                    params.url = 'complete';
                    break;
                case "0048": // 
                    params.url = 'feedBack';
                    params.title = '重新登录!';
                    params.message = '抱歉，您存在未完成的贷款申请。请重新登录！';
                    params.code = code;
                    params.showbutton = ['3']
                    break;
            }
            return params;
        }
    },
}

export { utils }



// WEBPACK FOOTER //
// ./src/assets/utils/utils.js